/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AuthRecoveryDialog.vue?vue&type=template&id=240ea03f"
import script from "./AuthRecoveryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthRecoveryDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AuthRecoveryDialog.vue?vue&type=style&index=0&id=240ea03f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports